module.exports = __webpack_public_path__ + "static/media/PDF(azul).0200a370.svg";